import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin/admin.service';
import { FileUploadService } from 'src/app/services/file-upload/file-upload.service';
import Quill from 'quill';
import { forkJoin } from 'rxjs';
const SizeStyle: any = Quill.import('attributors/style/size');

SizeStyle.whitelist = [
  '10px',
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '22px',
  '24px',
  '28px',
  '32px'
];

Quill.register(SizeStyle, true);


export interface VOCCourseDetailsUnitModel {
  id: number;
  fkVocCourseId: number;
  name: string;
  description: string;
  icon: string;
}



@Component({
  selector: 'app-admin-tags',
  templateUrl: './admin-tags.component.html',
  styleUrls: ['./admin-tags.component.scss']
})
export class AdminTagsComponent implements OnInit {
  dashboardOptions: any[] = [
    { label: 'Left Top', value: 'LEFT_TOP' },
    { label: 'Right Top', value: 'RIGHT_TOP' },
    { label: 'Bottom Left', value: 'BOTTOM_LEFT' },
    { label: 'Bottom Right', value: 'BOTTOM_RIGHT' }
  ];

  isResettingDashboard = false;
  rows: any[] = [];
  showDialog = false;
  editor: any = {};
  editorFields: any[] = [{ name: 'tagName', label: 'Tag' }, { name: 'slug', label: 'Slug' }];

  editorModules = {
    toolbar: [
      [
        {
          size: [
            '10px',
            '12px',
            '14px',
            '16px',
            '18px',
            '20px',
            '22px',
            '24px',
            '28px',
            '32px'
          ]
        }
      ],

      ['bold', 'italic', 'underline', 'strike'],

      [
        { header: 1 },
        { header: 2 }
      ],

      [
        { list: 'ordered' },
        { list: 'bullet' }
      ],

      [
        { indent: '-1' },
        { indent: '+1' }
      ],

      [
        { align: [] }
      ],

      [
        { color: [] },
        { background: [] }
      ],

      ['link'],

      ['clean']
    ]
  };


  showSaveMessageDialog: boolean = false;

  saveMessage: string = '';

  saveMessageType: 'success' | 'warning' | 'error' = 'warning';
  // Pagination variables
  currentPage: number = 1;
  pageSize: number = 10;

  // Dashboard popup variables
  showDashboardPopup = false;
  dashboardPopupType: 'confirm' | 'success' | 'error' = 'success';
  dashboardPopupTitle = '';
  dashboardPopupMessage = '';
  
  // Upload qualification image
   
isImageUploading: boolean = false;
  private dashboardConfirmAction: (() => void) | null = null;

  // Inject required services
  constructor(private adminService: AdminService, private uploadService: FileUploadService) { }
  // Load qualification list
  loadPageData(): void {

    this.adminService.getTags('ADMIN_LIST').subscribe({
      next: (data: any[]) => {

        this.rows = [...data]
          .map(row => ({
            ...row,
            dashboard: row.dashboard?.trim() || null
          }))
          .sort((a, b) => a.ranking - b.ranking);

        if (this.currentPage > this.totalPages) {
          this.currentPage = this.totalPages;
        }

      },
      error: error => {
        console.error('Failed to load qualifications:', error);
      }
    });

  }
  // Open new qualification dialog
  openNew(): void { this.editor = {}; this.showDialog = true; }
  // Open qualification edit dialog
  edit(row: any): void { this.editor = { ...row }; this.showDialog = true; }

  // Show save message dialog
  openSaveMessageDialog(
    message: string,
    type: 'success' | 'warning' | 'error'
  ): void {
    this.saveMessage = message;
    this.saveMessageType = type;
    this.showSaveMessageDialog = true;
  }

  // Close save message dialog
  closeSaveMessageDialog(): void {
    this.showSaveMessageDialog = false;
  }

  // Execute save function
  save(): void {

    const tagName = (this.editor.tagName || '').trim();

    if (!tagName) {
      this.openSaveMessageDialog(
        'Please enter qualification name.',
        'warning'
      );
      return;
    }

    // Assign qualification name to slug
    this.editor.tagName = tagName;
    this.editor.slug = tagName;
    this.editor.isVisible = true;

    this.adminService.saveTag(this.editor).subscribe({

      next: (response: any) => {

        if (response.message === 'exists') {
          this.openSaveMessageDialog(
            'This qualification already exists. Please use a different name.',
            'warning'
          );
          return;
        }

        if (response.isSuccess && response.message === 'saved') {
          this.showDialog = false;
          this.loadPageData();
          
          this.openSaveMessageDialog(
            'Qualification saved successfully.',
            'success'
          );
          return;
        }

        this.openSaveMessageDialog(
          'Failed to save qualification.',
          'error'
        );
      },

      error: (error) => {
        console.error('Failed to save qualification:', error);

        this.openSaveMessageDialog(
          'Failed to save qualification.',
          'error'
        );
      }

    });

  }

  // Load data on component initialization
  ngOnInit(): void {
    this.loadPageData();
  }


// Upload qualification image
uploadImage(event: Event): void {

  const input = event.target as HTMLInputElement;

  if (!input.files?.length || this.isImageUploading) {
    return;
  }

  const file = input.files[0];

  // Validate file size (5 MB)
  if (file.size > 5 * 1024 * 1024) {
    alert('Image size must not exceed 5 MB.');
    input.value = '';
    return;
  }

  // Validate image type
  const allowedTypes = [
    'image/jpeg',
    'image/png',
    'image/webp'
  ];

  if (!allowedTypes.includes(file.type)) {
    
     this.openSaveMessageDialog(
          'Only JPG, PNG and WebP images are allowed.',
          'error'
        );
    input.value = '';
    return;
  }

  this.isImageUploading = true;

  this.uploadService.uploadSingleFile(
    file,
    'course-images'
  ).subscribe({

    next: (x) => {

      if (x?.publicUrl) {
        this.editor.imageUrl = x.publicUrl;
      } else {
        
           this.openSaveMessageDialog(
          'Image upload failed.',
          'error'
        );
      }

      this.isImageUploading = false;
      input.value = '';
    },

    error: (e) => {

      console.error(e);
      this.openSaveMessageDialog(
          'Image upload failed.',
          'error'
        );

      this.isImageUploading = false;
      input.value = '';

    }

  });

}


  // Delete qualification
  delete(tagId: number): void {
    if (!confirm('Are you sure you want to delete this tag?')) return;
    this.adminService.deleteTag(tagId).subscribe({ next: () => this.loadPageData(), error: e => { console.error(e); alert('Tag delete failed.'); } });
  }

  // Update qualification order
  onRowReorder(event: any): void {

    const startIndex = (this.currentPage - 1) * this.pageSize;

    const dragIndex = startIndex + event.dragIndex;
    const dropIndex = startIndex + event.dropIndex;

    if (
      dragIndex < 0 ||
      dropIndex < 0 ||
      dragIndex >= this.rows.length ||
      dropIndex >= this.rows.length
    ) {
      return;
    }

    // Move the dragged record in the original array
    const updatedRows = [...this.rows];

    const [draggedRow] = updatedRows.splice(dragIndex, 1);

    updatedRows.splice(dropIndex, 0, draggedRow);

    // Update ranking based on the new order
    this.rows = updatedRows.map((row, index) => ({
      ...row,
      ranking: index + 1
    }));

    // Send updated order to API
    this.adminService.updateTagRanking(this.rows).subscribe({
      next: () => {
        console.log('Tag ranking updated successfully.');
      },
      error: error => {
        console.error(error);
        this.loadPageData();
      }
    });

  }




  // Get current page records
  get pagedTags(): any[] {

    const startIndex =
      (this.currentPage - 1) * this.pageSize;

    return this.rows.slice(
      startIndex,
      startIndex + this.pageSize
    );

  }


  // Calculate total pages
  get totalPages(): number {

    return Math.max(
      1,
      Math.ceil(
        this.rows.length / this.pageSize
      )
    );

  }


  // Get page numbers
  get pageNumbers(): number[] {

    return Array.from(
      { length: this.totalPages },
      (_, index) => index + 1
    );

  }


  // Get first displayed record
  get startRecord(): number {

    if (this.rows.length === 0) {
      return 0;
    }

    return (
      (this.currentPage - 1) * this.pageSize
    ) + 1;

  }


  // Get last displayed record
  get endRecord(): number {

    return Math.min(
      this.currentPage * this.pageSize,
      this.rows.length
    );

  }


  // Change current page
  changePage(page: number): void {

    if (
      !Number.isInteger(page) ||
      page < 1 ||
      page > this.totalPages
    ) {
      return;
    }

    this.currentPage = page;

  }


  // Go to previous page
  previousPage(): void {

    this.changePage(
      this.currentPage - 1
    );

  }


  // Go to next page
  nextPage(): void {

    this.changePage(
      this.currentPage + 1
    );

  }


  // Reset pagination on page size change
  onPageSizeChange(): void {

    this.currentPage = 1;

  }

  // Update qualification visibility
  toggleTagVisibility(row: any): void {

    if (row.isUpdatingVisibility) {
      return;
    }

    const previousVisibility = row.isVisible === true;

    row.isVisible = !previousVisibility;
    row.isUpdatingVisibility = true;

    const payload = {
      ...row,
      isVisible: row.isVisible
    };

    delete payload.isUpdatingVisibility;

    this.adminService.saveTag(payload).subscribe({

      next: () => {
        row.isUpdatingVisibility = false;

        console.log(
          'Tag visibility updated:',
          row.tagName,
          row.isVisible
        );
      },

      error: error => {

        row.isVisible = previousVisibility;
        row.isUpdatingVisibility = false;

        console.error('Tag visibility update failed:', error);

        alert('Failed to update tag visibility.');
      }

    });

  }

  // Check whether dashboard position is taken
  isDashboardOptionTaken(value: string, currentTagId: number): boolean {

    return this.rows.some(row =>
      row.dashboard?.trim() === value &&
      row.tagId !== currentTagId
    );

  }

  // Check assigned dashboard positions
  get hasDashboardAssignments(): boolean {

    return this.rows.some(row =>
      this.dashboardOptions.some(option =>
        option.value === row.dashboard?.trim()
      )
    );

  }
  // Check whether all positions are taken
  get areAllDashboardPositionsTaken(): boolean {

    return this.dashboardOptions.every(option =>
      this.rows.some(row =>
        row.dashboard?.trim() === option.value
      )
    );

  }

  // Check whether dashboard selection is disabled
  isDashboardSelectDisabled(row: any): boolean {

    if (row.dashboard?.trim()) {
      return false;
    }

    return this.areAllDashboardPositionsTaken;

  }

  // Update dashboard position
  onDashboardChange(row: any, selectedValue: string): void {

    if (row.isUpdatingDashboard || this.isResettingDashboard) {
      return;
    }

    const previousValue = row.dashboard?.trim() || null;

    const newValue = selectedValue?.trim() || null;

    if (previousValue === newValue) {
      return;
    }

    if (newValue && this.isDashboardOptionTaken(newValue, row.tagId)) {

      this.showDashboardMessage(
        'error',
        'Position Unavailable',
        'This dashboard position is already assigned to another tag.'
      );

      return;
    }

    row.dashboard = newValue;
    row.isUpdatingDashboard = true;

    const payload = {
      ...row,
      dashboard: newValue
    };

    delete payload.isUpdatingDashboard;
    delete payload.isUpdatingVisibility;

    this.adminService.saveTag(payload).subscribe({

      next: (response: any) => {

        row.isUpdatingDashboard = false;

        if (response?.success === false) {

          row.dashboard = previousValue;

          this.showDashboardMessage(
            'error',
            'Update Failed',
            'Failed to update dashboard position.'
          );

          return;
        }

        /* this.showDashboardMessage(
          'success',
          'Dashboard Updated',
          'Dashboard position updated successfully.'
        ); */

      },

      error: error => {

        row.dashboard = previousValue;
        row.isUpdatingDashboard = false;

        console.error(error);

        this.showDashboardMessage(
          'error',
          'Update Failed',
          'Failed to update dashboard position. Please try again.'
        );

      }

    });

  }

  // Confirm dashboard position reset
  resetDashboardPositions(): void {

    if (this.isResettingDashboard || !this.hasDashboardAssignments) {
      return;
    }

    this.showDashboardConfirmation(
      'Reset Dashboard Positions',
      'Are you sure you want to clear all assigned dashboard positions?',
      () => this.executeDashboardReset()
    );

  }


  // Execute dashboard position reset
  executeDashboardReset(): void {

    const assignedRows = this.rows.filter(row => !!row.dashboard);

    if (assignedRows.length === 0) {
      return;
    }

    this.isResettingDashboard = true;

    const requests = assignedRows.map(row => {

      const payload = {
        ...row,
        dashboard: null
      };

      delete payload.isUpdatingDashboard;
      delete payload.isUpdatingVisibility;

      return this.adminService.saveTag(payload);

    });

    forkJoin(requests).subscribe({

      next: (responses: any[]) => {

        this.isResettingDashboard = false;

        if (responses.some(response => response?.success === false)) {

          this.loadPageData();

          this.showDashboardMessage(
            'error',
            'Reset Incomplete',
            'Some dashboard positions could not be reset.'
          );

          return;
        }

        // Reset all dropdowns to None
        this.rows = this.rows.map(row => ({
          ...row,
          dashboard: null
        }));

        this.showDashboardMessage(
          'success',
          'Dashboard Reset',
          'All dashboard positions have been reset to None successfully.'
        );

      },

      error: error => {

        this.isResettingDashboard = false;
        this.loadPageData();

        console.error(error);

        this.showDashboardMessage(
          'error',
          'Reset Failed',
          'Failed to reset dashboard positions.'
        );

      }

    });

  }




  // Show dashboard message
  showDashboardMessage(
    type: 'success' | 'error',
    title: string,
    message: string
  ): void {

    this.dashboardConfirmAction = null;
    this.dashboardPopupType = type;
    this.dashboardPopupTitle = title;
    this.dashboardPopupMessage = message;
    this.showDashboardPopup = true;

  }


  // Show dashboard confirmation
  showDashboardConfirmation(
    title: string,
    message: string,
    action: () => void
  ): void {

    this.dashboardPopupType = 'confirm';
    this.dashboardPopupTitle = title;
    this.dashboardPopupMessage = message;
    this.dashboardConfirmAction = action;
    this.showDashboardPopup = true;

  }


  // Close dashboard popup
  closeDashboardPopup(): void {
    this.showDashboardPopup = false;
    this.dashboardConfirmAction = null;
  }


  // Execute confirmed dashboard action
  confirmDashboardPopup(): void {

    const action = this.dashboardConfirmAction;

    this.closeDashboardPopup();

    if (action) {
      action();
    }

  }
}
